import { useState, useRef } from 'react'
import { Modal, Form, Button } from 'react-bootstrap'
import { useForm } from 'react-hook-form'
import InputWrapper from 'shared/components/InputWrapper'
import useInit from './hooks/useInit'
import resEmailMessage from './resolvers/resEmailMessage'
import submitForm from './utils/submitForm'

interface SendEmailModalProps {
  selectedUsers: any
  showModal: boolean
  setShowModal: Function
  confirmAction?: Function
}

const SendEmailModal: React.FunctionComponent<SendEmailModalProps> = (props) => {
  const [modalLoaded, setModalLoaded] = useState<boolean>(false)
  const [isRequestLoading, setIsRequestLoading] = useState<boolean>(false)

  const {
    register,
    getValues,
    handleSubmit,
    reset,
    setFocus,
    formState: { errors },
    setError,
  } = useForm({
    mode: 'all',
    resolver: resEmailMessage,
  })

  useInit({
    ...props,
    setModalLoaded,
  })

  const handleModalHide = () => {
    reset()
    props.setShowModal(false)
  }

  const submitButtonRef: any = useRef(null)

  return (
    <Modal show={props.showModal && modalLoaded} onHide={() => handleModalHide()} animation={true}>
      <Modal.Header closeButton>
        <Modal.Title>Send E-mail Message</Modal.Title>
      </Modal.Header>

      <Form
        onSubmit={handleSubmit((data) => {
          submitForm({
            setIsRequestLoading: setIsRequestLoading,
            selectedUsers: props.selectedUsers,
            setError: setError,
            handleModalHide: handleModalHide,
            data: data,
          })
        })}
        id='send-email-form'
      >
        <Modal.Body>
          <InputWrapper colAttributes={{ md: 12 }} label='Subject' name='subject' errors={errors}>
            <Form.Control type='text' {...register('subject')} />
          </InputWrapper>

          <InputWrapper colAttributes={{ md: 12 }} label='Text' name='text' errors={errors}>
            <Form.Control as='textarea' rows={3} {...register('text')} />
          </InputWrapper>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant='secondary'
            onClick={() => {
              handleModalHide()
            }}
          >
            Close
          </Button>
          <Button disabled={isRequestLoading} type='submit' variant='primary'>
            {isRequestLoading && (
              <>
                <span
                  className='spinner-border spinner-border-sm'
                  role='status'
                  aria-hidden='true'
                ></span>
                &nbsp;
              </>
            )}
            Send
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  )
}

export default SendEmailModal
